import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {FormControl} from '@angular/forms';

import {RequestParameters, FieldRequestParameters} from '../../models/request-parameters/parameter.model';
import {AgencyService} from '../../../agency/agency.service';
import {Agency} from '../../../agency/agency.model';
import { UsersPartnerService } from '../../../users/users-partner/users-partner.service';

@Component({
  selector: 'app-agencies-autocomplete',
  templateUrl: './agencies-autocomplete.component.html',
  styleUrls: ['./agencies-autocomplete.component.scss']
})
export class AgenciesAutocompleteComponent implements OnInit {

  @Input('agencyFormControl') agencyFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onAgencySelected: EventEmitter<Agency> = new EventEmitter<Agency>();

  @ViewChild('autoParent') autoParent: ElementRef;

  agencies: Observable<any> = new Observable<any>();
  agencyLoading: boolean = true;
  agencyParameters: RequestParameters = new RequestParameters();
  organizationValue: any;

  constructor(private agencyService: AgencyService, private userPartnerService: UsersPartnerService) {
    this.userPartnerService.onOrganizationChangeRecieve().subscribe(
      (organization) => {
        this.organizationValue = organization;
        this.agencyParameters.fields = [];
        this.agencyParameters.fields.push(new FieldRequestParameters('organization', organization.reference));
        this.updateAgency();
      }
    );
  }

  ngOnInit() {

    if (!this.organizationValue) {
      this.updateAgency();
    }
  }

  onSelectAgency() {
    this.onAgencySelected.emit(this.agencyFormControl.value);
  }


  displayAgency (agency: Agency) {
    if (agency !== null) {
      return agency.name;
    }
  }

  filterAgencies (filterInput: string = '') {
    if (this.agencyParameters.searchString !== filterInput) {
      this.agencyParameters.searchString = filterInput;
      this.updateAgency();
    }
  }

  updateAgency () {
    this.agencyLoading = true;
    this.agencies = this.agencyService.getAgencies(this.agencyParameters)
      .map(
        (response) => {
          this.agencyLoading = false;
          return response.result;
        }
      );
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/agencies-autocomplete/agencies-autocomplete.component.ts